<div class="step_container" [formGroup]="form">
    <div class="step no_step">
      <div class="step_title inline_title">
        <span>
          {{"inventory.variants_management"|translate}}
        </span>
        <button (click)="closed()">
          <mat-icon style="color: black;">close</mat-icon>
        </button>
      </div>
      <div class="block_attribute">
        <div class="content inline attributes" *ngFor="let attribute of attributes; let i = index">
          <div class="field attribut category_field">
            <label for="" *ngIf="i === 0">{{"inventory.attribute"|translate}}</label>
            <input type="text" [value]="attribute.name"
               [placeholder]="'inventory.attribute'|translate" disabled>
          </div>
          <div class="field values">
            <label for="" *ngIf="i === 0">{{"inventory.values"|translate}}</label>
            <mat-chip-list #chipList aria-label="Attribute Values">
              <mat-chip *ngFor="let value of attribute.values; let j = index">
                {{value}}
              </mat-chip>
            </mat-chip-list>
          </div>
        </div>
      </div>
      <div class="variantes">
        <div class="step_title variants_title">
          <span>
            {{variants.length}} {{"inventory.variants_included"|translate}}
          </span>
          <div class="btn_attributes">
              <div class="currencies">
                {{"common.currencies"|translate}}: 
                <div class="currency_tag">
                  {{ default_currency?.name }} ({{ default_currency?.symbol }})
                </div>
                <div class="currency_tag" *ngFor="let currency of currenciesToDisplay">
                  {{ getCurrencyName(currency.currency_id!) }} ({{ getCurrencySymbol(currency.currency_id!) }})
                  <button class="remove_currency" *appHasPermission="{ module: 'product', action: 'edit' }" (click)="removeCurrency(currency.currency_id!)">
                    <mat-icon style="color: #ed8787;">remove_circle_outline</mat-icon>
                  </button>
              </div>
            </div>
            <ng-container *appHasPermission="{ module: 'product', action: 'edit' }">
              <span *ngIf="availableCurrencies.length > 0" class="add-currency-button" #dropdown>
                <button class="add_attr small_btn_add" type="button" (click)="openCurrenciesDropdown($event)">
                  <img src="../../../../../assets/icones/add_icon.svg" alt="">
                  <span> {{"common.add"|translate}} </span>
                </button>

                <div *ngIf="showCurrencyDropdown" class="currency-dropdown"
                  [style.top.px]="currenciesDropdown.top"
                  [style.left.px]="currenciesDropdown.left"
                  [style.minWidth.px]="currenciesDropdown.minWidth"
                >
                  <ul>
                    <li *ngFor="let currency of availableCurrencies" (click)="addCurrency(currency)">
                      {{ currency.name }} ({{ currency.symbol }})
                    </li>
                  </ul>
                </div>
              </span>
            </ng-container>
          </div>
        </div>
        <div class="header_variant th_variant">
          <div>{{"Catalogs.variant"|translate}}</div>
          <div>{{"inventory.sku"|translate}}</div>
          <div>{{"inventory.current_inventory"|translate}}</div>
          <div>{{"inventory.reorder_point"|translate}}</div>
          <div>{{"inventory.retail_pricee"|translate}}</div>
          <div>{{"inventory.product_cost_(cogs)"|translate}}</div>
        </div>
        <div class="seperater header_panel"></div>
        <div class="div_panel" *ngFor="let variant of variants; let i = index">
          <mat-expansion-panel class="mat_panel">
            <mat-expansion-panel-header>
              <div class="header_variant">
                <div class="first_th_variant">
                  <img class="icon_user" (click)="$event.stopPropagation()"
                    [src]="getImage(variant)"
                    alt="image variante"
                    (error)="onImageError(variant.image!)"
                  >
                  {{ variant.values.join('/ ')}}
                </div>
                <div>
                  <input class="input_table" [value]="form.get('sku_' + variant.id)?.value" type="text" [formControlName]="'sku_' + variant.id" [placeholder]="'inventory.sku'|translate"
                  (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()">
                </div>
                <div>
                  <input class="input_table" type="number" [placeholder]="'inventory.current_inventory'|translate"
                    [formControlName]="'quantity_' + variant.id" [value]="form.get('quantity_' + variant.id)?.value"
                    (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                    (keydown.space)="$event.stopPropagation()">
                </div>
                <div>
                  <input class="input_table" type="number" [placeholder]="'inventory.min_inventory'|translate"
                    [formControlName]="'reorder_point_' + variant.id" [value]="form.get('reorder_point_' + variant.id)?.value"
                    (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                    (keydown.space)="$event.stopPropagation()">
                </div>
                <div>
                  <div class="input_price_container">
                    <input class="input_table" type="number" min="0" [formControlName]="'sales_price_'+ variant.id" [value]="form.get('sales_price_' + variant.id)?.value" [placeholder]="'inventory.priced'|translate"
                    (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                    (keydown.space)="$event.stopPropagation()" (input)="sanitizePrice($event)">
                  </div>
                </div>
                <div>
                  <div class="input_price_container">
                    <input class="input_table" type="number" min="0" [formControlName]="'cost_' + variant.id" [value]="form.get('cost_' + variant.id)?.value" [placeholder]="'inventory.pricef'|translate"
                    (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                    (keydown.space)="$event.stopPropagation()" (input)="sanitizePrice($event)">
                  </div>
                </div>
                <div>
                  <mat-slide-toggle class="checkbox_table" [formControlName]="'enabled_' + variant.id" [checked]="form.get('enabled_' + variant.id)?.value"
                  (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()"></mat-slide-toggle>
                </div>
              </div>
            </mat-expansion-panel-header>
            <div class="content_panel">
              <div class="content">
                <div class="variants_block">
                  <div class="variant_img">
                    <div class="title_panels">{{"inventory.photo"|translate}}</div>
                    <div class="content_img" (change)="getVariantImg($event, i)" for="upload">
                      <input class="file" type="file" id="upload" accept="image/jpeg, image/png, image/gif">
                      <img [class]="variant.image ? 'icon_variant' : 'icon_user'"
                        [src]="getImage(variant)"
                        alt="image variante"
                        (error)="onImageError(variant.image!)"
                        >
                        <span *ngIf="!variant.image">{{"inventory.click_to_upload"|translate}}</span>
                        <button *ngIf="variant.image" class="cancel_upl_variant" (click)="cancelImageVariant(i)">
                          <mat-icon class="cancel_icon">cancel</mat-icon>
                        </button>
                    </div>
                  </div>
                  <div class="skus_codes">
                    <div class="title_panels">{{"inventory.sKU_code"|translate}}</div>
                    <div class="inline_block">
                      <div class="field ">
                        <label for="">{{"inventory.sku_code_type"|translate}}</label>
                        <select name="" id="" disabled>
                          <option selected value="">{{"inventory.statics_input"|translate}}</option>
                        </select>
                      </div>
                      <div class="field ">
                        <label for="">{{"inventory.sKU_code"|translate}}<span class="red">*</span></label>
                        <input [value]="form.get('sku_' + variant.id)?.value" type="text" [formControlName]="'sku_' + variant.id" [placeholder]="'inventory.sku'|translate">
                      </div>
                      <div class="field ">
                        <label for="">{{"inventory.barcode"|translate}}</label>
                        <input type="number" [placeholder]="'inventory.barcode'|translate" type="text" [formControlName]="'bar_code_' + variant.id" class="input" (input)="sanitize($event)">
                      </div>
                    </div>
                    <div class="inline_block">
                      <div class="field ">
                        <label for="">{{"inventory.expiration_date"|translate}}</label>
                        <input type="Date" [formControlName]="'expiry_date_' + variant.id" [placeholder]="'inventory.expiration_date'|translate"  class="input">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="insede_seperator"></div>
                <div class="variants_block">
                  <div class="details_block left_step_variants">
                    <div class="title_panels">
                      <span>
                        {{"inventory.inventory_levels"|translate}}
                      </span>
                    </div>
                    <div class="content">
                      <div class="inline_block">
                        <div class="field">
                          <label for="">{{"inventory.current_inventory"|translate}}</label>
                          <input value="" type="number" [placeholder]="'inventory.current_inventory'|translate"
                          [formControlName]="'quantity_' + variant.id" [value]="form.get('quantity_' + variant.id)?.value">                            </div>
                        <div class="field">
                          <label for="">{{"inventory.re-order_point"|translate}}</label>
                          <input value="" type="number" [placeholder]="'inventory.min_inventory'|translate"
                          [formControlName]="'reorder_point_' + variant.id" [value]="form.get('reorder_point_' + variant.id)?.value">                            </div>
                      </div>
                      <div class="inline_block">
                        <div class="field">
                          <label for="reorder_point">{{"Catalogs.order_quantity_rules"|translate}}</label>
                          <div class="inline_block">
                            <div class="field">
                              <input type="number" [formControlName]="'min_qte_' + variant.id" [value]="form.get('min_qte_' + variant.id)?.value" (input)="sanitize($event)">
                              <span class="indicate_input custom_indic">{{"Catalogs.min" | translate}}</span>
                            </div>
                            <div class="field">
                              <input type="number" [formControlName]="'increment_' + variant.id" [value]="form.get('increment_' + variant.id)?.value" (input)="sanitize($event)">
                              <span class="indicate_input custom_indic">{{"Catalogs.increment"| translate}}</span>
                            </div>
                            <div class="field">
                              <input type="number" [formControlName]="'max_qte_' + variant.id" [value]="form.get('max_qte_' + variant.id)?.value" (input)="sanitize($event)">
                              <span class="indicate_input custom_indic">{{"Catalogs.max" | translate}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="small_seperator"></div>
                  <div class="details_block right_step_variants">
                    <div class="title_panels">
                      <span>
                        {{"inventory.pricing"|translate}}
                      </span>
                    </div>
                      <div class="content">
                        <div class="inline_block">
                          <div>
                            <div class="field ">
                              <label for="">{{"inventory.retail_pricee"|translate}}<span class="red">*</span></label>
                              <input [formControlName]="'sales_price_'+ variant.id" [value]="form.get('sales_price_' + variant.id)?.value" type="number" min="0" [placeholder]="'inventory.retail_pricee'|translate" (input)="sanitizePrice($event)">
                              <span class="indicate_input">€</span>
                              <span class="error_ms" *ngIf="form.get('sales_price_' + variant.id)?.touched && form.get('sales_price_' + variant.id)?.errors?.['required']">
                                {{ "common.required_field" | translate }}
                              </span>
                              <span class="error_ms" *ngIf="form.get('sales_price_' + variant.id)?.touched && form.get('sales_price_' + variant.id)?.errors?.['min']">
                                {{ "inventory.price_must_be_positive" | translate }}
                              </span>
                            </div>
                            <div *ngFor="let currency of addedCurrencies">
                              <div *ngIf="currency.variantId === variant.id" class="input_price_container" [formGroup]="currency.controls.retail_price">
                                <input class="input_table" type="number" formControlName="amount"
                                  [value]="currency.controls.retail_price?.get('amount')?.value"
                                  [placeholder]="'inventory.retail_price_currency' | translate:{currency: currency.data.name}"
                                  (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                                  (keydown.space)="$event.stopPropagation()" (input)="sanitizePrice($event)">
                                <span [title]="currency.data.name" class="indicate_input">{{ currency.data.symbol }}</span>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div class="field ">
                              <label for="">{{"inventory.product_cost_(cogs)"|translate}}<span class="red">*</span></label>
                              <input type="number" min="0" [placeholder]="'inventory.product_cost_(cogs)'|translate" [formControlName]="'cost_' + variant.id" [value]="form.get('cost_' + variant.id)?.value" (input)="sanitizePrice($event)">
                              <span class="indicate_input">€</span>
                              <span class="error_ms" *ngIf="form.get('cost_' + variant.id)?.touched && form.get('cost_' + variant.id)?.errors?.['min']">
                                {{ "inventory.price_must_be_positive" | translate }}
                              </span>
                            </div>
                            <div *ngFor="let currency of addedCurrencies">
                              <div *ngIf="currency.variantId === variant.id" class="input_price_container" [formGroup]="currency.controls.cost">
                                <input class="input_table" type="number" formControlName="amount"
                                  [value]="currency.controls.cost?.get('amount')?.value"
                                  [placeholder]="'inventory.product_cost_(cogs)_currency' | translate:{currency: currency.data.name}"
                                  (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                                  (keydown.space)="$event.stopPropagation()" (input)="sanitizePrice($event)">
                                <span [title]="currency.data.name" class="indicate_input">{{ currency.data.symbol }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="field">
                            <label for="" class="slide_label">
                              <mat-slide-toggle disabled>
                              </mat-slide-toggle>
                              {{"inventory.charge_tax"|translate}}
                            </label>
                            <select name="" id="" disabled>
                              <option selected value="">{{"inventory.default_tax"|translate}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
      </div>
    </div>
    <div class="submet_btns">
        <button class="save_btn_pop_up cancel_btn_pop_up" (click)="closed()">
          <span>{{"common.back"|translate | uppercase}}</span>
          <img src="../../../../../assets/icones/arrow_back.svg" alt="">
        </button>
        <button class="save_btn_pop_up blue_btn" *appHasPermission="{ module: 'product', action: 'edit' }" (click)="save()">
            <span>{{"common.save"|translate | uppercase}}</span>
            <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
        </button>
      </div>
  </div>
